<template>
<div
  class="sub-category-list nowrap-list"
>
  <div
    v-for="(labelItem, idx) in labels"
    :key="idx"
    class="sub-item"
    @click="handleCtgClick(labelItem)"
  >
    <div class="inner-item">
      <div class="icon">
        <img :src="$cvWebpFn(labelItem.iconUrl)" />
        <span class="select-icon">
          <van-icon name="success" color="#fff" />
        </span>
      </div>
      <p class="title-text">{{ labelItem.displayName }}</p>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import { sourceToPipeParts } from '@/utils/traffic-source'

export interface ILabel {
  displayName: string
  iconUrl: string
  boundCategoryIds: number[]
  boundKeywords: string
}
defineProps<{ labels: ILabel[] }>()
const route = useRoute()
const router = useRouter()

/** 品类标签点击：type=labelSearch，value / firstPage 保持不变 */
const buildLabelSearchSource = () => {
  const currentSource = decodeURIComponent(String(route.query.source || ''))
  const [module, , value, firstPage] = sourceToPipeParts(currentSource)

  return [
    module || 'searchProduct',
    'labelSearch',
    value,
    firstPage || 'searchProductResults',
    'searchProductResults'
  ].join('|')
}

const handleCtgClick = async (item: ILabel) => {
  const { boundKeywords, boundCategoryIds } = item
  const query = {
    q: boundKeywords,
    backCid: boundCategoryIds.join('_'),
    source: buildLabelSearchSource()
  }

  const url = router.resolve({ path: '/search', query, replace: true })

  window.location.href = url.href
}
</script>

<style lang="scss" scoped>
.sub-category-list{
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  background-color: #fff;
  .sub-item{
    width: 20%;
    padding: 5px;
    box-sizing: border-box;
    overflow: hidden;
    
    .inner-item{
      .icon{
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        position: relative;
        border: 1px solid transparent;
        border-radius: 6px;
        overflow: hidden;
        img{
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .select-icon{
          display: none;
          position: absolute;
          z-index: 9;
          bottom: -18px;
          right: -18px;
          height: 50px;
          width: 50px;
          padding: 5px 0 0 5px;
          background-color: var(--default_color);
          border-radius:  50%;

        }
      }
      .title-text{
        font-size: 24px;
        color: #333;
        margin-top: 8px;
        text-align: center;
        @include ellipsisMultiline(2);
      }
    }
  }
}

.nowrap-list{
  flex-wrap: nowrap;
  overflow: auto;
  &::-webkit-scrollbar{
    display: none;
  }
  .sub-item{
    min-width: 20%;
  }
}
</style>